/**
 * Module dependencies.
 */

import { JSX, ReactNode } from 'react';
import { SubTitleComponent } from './sub-title.style';

/**
 * `Props` type.
 */

type Props = {
  children?: ReactNode;
  className?: string;
};

/**
 * Export `SubTitle` component.
 */

export function SubTitle({ children, className }: Props): JSX.Element {
  return (
    <SubTitleComponent className={className}>{children}</SubTitleComponent>
  );
}
